import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  OnDestroy,
  Output,
  EventEmitter,
} from '@angular/core';
import { ViewOrder } from 'src/app/shared/interfaces/views.interface';
import { Store } from '@ngrx/store';
import { appState } from 'src/app/shared/interfaces/appState.interface';
import { PRODUCT_NAMES } from '@shared-logic/products';
import { teams } from '@shared-logic/user';
import { orderStates } from 'src/app/shared/dict/orders';
import { typeBusiness } from '@shared-logic/business-type';
import { sellerWithData } from 'src/app/shared/dict/seller-with-data';
import { buyers } from 'src/app/shared/dict/buyers';
import { wayPay } from '@shared-logic/payments';
import { DateChecker } from '@shared-logic/utils';
import { STATES_ORDERS_VALIDS } from 'src/app/pages/order-list/body-order-list/order-table/commodities/commodities.component';
import { OPTION } from '../../options/options.component';
import { RowHead } from '../../row-head';
import { conditionType } from 'src/app/shared/const/options';
import { quality } from '@shared-logic/qualities';
import { puertos } from '@shared-logic/locations';
import { typeCoin } from '@shared-logic/prices';
import { BUSINESS_PARTICULARITIES_FILTER_OPTIONS } from 'src/app/shared/utils/business-particularities-filter.util';
import { broker } from '@shared-logic/subjects';
import { orderOriginConst } from '@shared-logic/orders';

@Component({
  selector: 'tr[row-head]',
  templateUrl: './row-head.component.html',
  styleUrls: ['./row-head.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RowHeadComponent extends RowHead implements OnInit, OnDestroy {
  @Input() isControlPanel: boolean = false;
  @Input() viewSelected!: ViewOrder;
  @Input() conditionTypeSelected!: string;
  @Input() showBuyer: boolean = true;
  @Input() showAutorizateAll: boolean = false;
  @Input() showDownloadCSV: boolean = false;

  public STATES_ORDERS_VALIDS = [
    ...STATES_ORDERS_VALIDS,
    'Contrato',
    'Borrador',
  ];
  STATUS: any = [];
  BUSINESS_TYPE: any = [];
  PLACE_OF_DELIVERY: any = [];
  QUALITY: any = [];
  TYPE_COIN: any = [];
  WAY_PAY: any = [];
  PRODUCTS: any = [];
  OBSERVATIONS: any = [];
  ORDER_ORIGIN: { [key: number]: string } = {
    [orderOriginConst.manual]: 'Orden manual',
    [orderOriginConst.desdeTablero]: 'Orden del tablero',
    [orderOriginConst.desdeTableroModificada]: 'Orden modificada',
  };
  HARVEST: any = [];
  SELLERS: any = [];
  TABLES: any = [];
  BUYERS: any = [];
  BROKER: { [key: string]: string } = {};
  BUSINESS_PARTICULARITIES: string[] = BUSINESS_PARTICULARITIES_FILTER_OPTIONS;

  CONDITION_TYPES = conditionType;

  constructor(
    private store: Store<appState>,
    private date: DateChecker,
    private cdr: ChangeDetectorRef,
  ) {
    super();
  }

  ngOnInit(): void {
    this.setArrays();
  }

  ngOnDestroy() {}

  setArrays() {
    this.STATUS = orderStates;
    this.BUSINESS_TYPE = typeBusiness;
    this.QUALITY = quality;
    this.PLACE_OF_DELIVERY = puertos;
    this.TYPE_COIN = typeCoin;
    this.WAY_PAY = wayPay;
    this.PRODUCTS = PRODUCT_NAMES;
    this.HARVEST = this.date.getHarvest();
    this.SELLERS = sellerWithData;
    this.TABLES = teams;
    this.BUYERS = buyers;
    this.BROKER = broker;
  }

  autorizateAll() {
    this.actions.emit(OPTION.AUTORIZATE_ALL);
  }

  emitAction(action: string) {
    this.actions.emit(action);
  }

  downloadCSV() {
    this.actions.emit(OPTION.DOWNLOAD_CSV);
  }
}
